import React from 'react'
import { useIntl } from 'react-intl'
import { Checkbox } from '../checkbox'
import { WithTooltip } from '../../design-system'

interface Props {
  isGroupBySinkEnabled: boolean
  toggleGroupBySink: () => void
  licensedOnly: boolean
  toggleBothCheckboxes: () => void
}

export const groupBySinkCheckboxId = 'group-by-sink-checkbox-test-id'

export function GroupBySinkCheckbox({
  isGroupBySinkEnabled,
  toggleGroupBySink,
  licensedOnly,
  toggleBothCheckboxes
}: Props) {
  const { formatMessage } = useIntl()

  return (
    <WithTooltip
      renderTooltipContent={() => (
        <span>{formatMessage({ id: 'detail_groupBySink_tooltip' })}</span>
      )}
    >
      {() => (
        <Checkbox
          onChange={() => {
            if (!licensedOnly) {
              toggleBothCheckboxes()
            } else {
              toggleGroupBySink()
            }
          }}
          value={isGroupBySinkEnabled}
          label={formatMessage({
            id: 'description_vulnerabilities_groupBySink'
          })}
          data-testid={groupBySinkCheckboxId}
          data-e2e={groupBySinkCheckboxId}
        />
      )}
    </WithTooltip>
  )
}
